import { render, staticRenderFns } from "./InfoDashboard.vue?vue&type=template&id=8aadc80c&scoped=true&"
import script from "./InfoDashboard.vue?vue&type=script&lang=js&"
export * from "./InfoDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InfoDashboard.vue?vue&type=style&index=0&id=8aadc80c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aadc80c",
  null
  
)

export default component.exports